export default class Pluton {

    constructor() {
        this.classes = this.importAll();
        this.setup();
        this.setEvents();
    }

    setup(root) {
        for (var className in this.classes) {
            this.setupComponent(className, this.classes[className], root);
        }
    }

    setupComponent(className, component, root) {
        if (!component.selector) return;
        [].forEach.call((root||document).querySelectorAll(component.selector + ':not([data-pluton-active="true"])'), (el) => {
            //if (el.dataset.plutonActive === 'true') return;
            if (!this[className]) this[className] = [];
            this[className].push(new component(el));
            el.dataset.plutonActive = true;
        });
    }

    call(className, fn, parameters) {
        if (!this[className]) return;
        for (var i = this[className].length - 1; i >= 0; i--) {
            this[className][i][fn](parameters);
        }
    }

    importAll() {
        var context = require.context(PLUTON_PATH, true, /\.js$/);
        var obj = {};
        context.keys().forEach(key => {
            let code = context(key);
            obj[code.default.selector] = code.default;
        });
        return obj;
    }

    setEvents() {
        window.addEventListener('vegout-pluton-update', this.e_update_part.bind(this));
    }

    e_update_part(e) {
        this.setup(e.detail.el);
    }
}